import axios from 'axios'
// import qs from 'qs'
const instance = axios.create({
    timeout: 5000,
    baseURL: 'https://newsapi.ebs.org.cn/api/EbsInfo/'
});
//请求拦截
instance.interceptors.request.use(config => {
    return config
}, function(error) {
    console.log(error)
    return Promise.reject(error)
});
//请求后返回数据拦截
instance.interceptors.response.use(response => {
    return response
}, function(err) {
    return Promise.reject(err)
});
//首页新闻动态/行业资讯列表获取
export function GetPage(type, pageindex) {
    return instance({
        url: '/GetPage?type=' + type + '&pageindex=' + pageindex + '&pagesize=5',
        method: 'get',
    })
}
//根据新闻id获取新闻内容
export function GetInfoReleaseById(id) {
    return instance({
        url: '/GetInfoReleaseById?id=' + id,
        method: 'get',
    })
}
// 获取首页大图,根据排序号正序取前5张
export function GetHomeImages() {
    return instance({
        url: '/GetHomeImages',
        method: 'get',
    })
}
//获取活动列表,根据排序号正序取前4条
export function GetActivityList() {
    return instance({
        url: '/GetActivityList',
        method: 'get',
    })
}
// export function get(url, params) {
//     return instance.get(url, { params });
// }
// export function post(url, data) {
//     return instance.post(url, data)
// }
export default instance